export default function AdminPricingManagement() {
  return (
      <p>نظارت بر قیمت گذاری</p>
  );
};